// エラー関連の型定義

// エラーコードの列挙
export const ErrorCodes = {
  // 認証関連
  AUTH_INVALID_CREDENTIALS: 'AUTH_INVALID_CREDENTIALS',
  AUTH_TOKEN_EXPIRED: 'AUTH_TOKEN_EXPIRED',
  AUTH_UNAUTHORIZED: 'AUTH_UNAUTHORIZED',
  AUTH_FORBIDDEN: 'AUTH_FORBIDDEN',

  // バリデーション関連
  VALIDATION_REQUIRED: 'VALIDATION_REQUIRED',
  VALIDATION_INVALID_FORMAT: 'VALIDATION_INVALID_FORMAT',
  VALIDATION_TOO_LONG: 'VALIDATION_TOO_LONG',
  VALIDATION_TOO_SHORT: 'VALIDATION_TOO_SHORT',

  // リソース関連
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  RESOURCE_ALREADY_EXISTS: 'RESOURCE_ALREADY_EXISTS',
  RESOURCE_LIMIT_EXCEEDED: 'RESOURCE_LIMIT_EXCEEDED',

  // サーバーエラー
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
  RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',

  // ネットワーク関連
  NETWORK_ERROR: 'NETWORK_ERROR',
  TIMEOUT_ERROR: 'TIMEOUT_ERROR',

  // デフォルト
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];

// エラーの基本インターフェース
export interface BaseError {
  name: string;
  message: string;
  stack?: string;
}

// APIエラーの詳細
export interface ApiErrorDetails {
  field?: string;
  value?: unknown;
  constraint?: string;
  [key: string]: unknown;
}

// ネットワークエラーの型
export interface NetworkErrorInfo extends BaseError {
  name: 'NetworkError';
  type?: 'connection' | 'timeout' | 'dns' | 'unknown';
}

// バリデーションエラーの型
export interface ValidationErrorInfo extends BaseError {
  name: 'ValidationError';
  field: string;
  details?: ApiErrorDetails;
}

// APIエラーの型
export interface ApiErrorInfo extends BaseError {
  name: 'APIError';
  status: number;
  code: ErrorCode;
  details?: ApiErrorDetails;
  requestId?: string;
}

// 統合エラー型
export type AppError = NetworkErrorInfo | ValidationErrorInfo | ApiErrorInfo | Error;

// エラーハンドリングのコンテキスト
export interface ErrorContext {
  operation?: string;
  endpoint?: string;
  userId?: string;
  timestamp?: string;
  extra?: Record<string, unknown>;
}

// リトライ設定
export interface RetryConfig {
  maxAttempts?: number;
  delay?: number;
  backoffMultiplier?: number;
  retryableErrors?: ErrorCode[];
}

// エラーハンドラーの型
export type ErrorHandler = (error: AppError, context?: ErrorContext) => void | Promise<void>;

// エラーレポーティング設定
export interface ErrorReportingConfig {
  enabled: boolean;
  endpoint?: string;
  includeStackTrace?: boolean;
  includeUserInfo?: boolean;
  customFields?: Record<string, unknown>;
}
